import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	icon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noValueTextExperiment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	icon: {
		id: 'issue-field-parent-readview-full.parent.icon',
		defaultMessage: '{issueType} icon',
		description: 'Alt text explainer for the parent issue type icon, i.e. Epic icon',
	},
	noValueTextExperiment: {
		id: 'issue-field-parent.no-value-text-experiment',
		defaultMessage: 'Add parent',
		description: 'Message when the field has no value',
	},
});
export default messages;
